<template>
    <v-card flat class="sub-site-wrapper">
        <div class="chart-component-wrapper">
            <div class="statistics-meta">
                <p>Email Connections gesamt: {{ totalConnections }}</p>
                <p>Datensatz erstellt am: {{ statisticsAge }}</p>
            </div>
            <div class="chart-controls">
                <v-btn-toggle variant="outlined" rounded="lg" v-model="chartType">
                    <v-btn value="bar">Bar</v-btn>
                    <v-btn value="line">Line</v-btn>
                    <v-btn value="area">Area</v-btn>
                    <v-btn value="pie">Pie</v-btn>
                </v-btn-toggle>
            </div>
            <apexchart v-if="!loading" :key="chartType" :type="chartType" height="400" :options="chartOptions"
                :series="chartSeries">
            </apexchart>
            <p v-else>Loading...</p>
        </div>
    </v-card>
</template>

<script>
import { defineComponent } from 'vue';
import { mapState } from 'vuex';
import VueApexCharts from 'vue3-apexcharts';

export default defineComponent({
    name: 'MyApexBarChart',
    components: {
        apexchart: VueApexCharts
    },
    data() {
        return {
            chartType: 'bar'  // Default chart type
        };
    },
    computed: {
        ...mapState('statistics', ['emailConnections', 'loading', 'statisticsAge']),
        totalConnections() {
            // Calculate the total number of email connections by summing the count of each type
            return this.emailConnections[0]?.past30DaysCount.reduce((total, type) => total + type.count, 0) || 0;
        },
        chartSeries() {
            const data = this.emailConnections[0]?.past30DaysCount || [];
            // Handle series format for pie chart separately
            return this.chartType === 'pie'
                ? data.map(item => item.count)
                : [{
                    name: 'Count',
                    data: data.map(item => item.count)
                }];
        },
        chartOptions() {
            const data = this.emailConnections[0]?.past30DaysCount || [];
            return {
                chart: {
                    type: this.chartType  // Use dynamic chart type
                },
                colors: this.chartType === 'pie' ? ['#783597', '#FF5733', '#C70039', '#900C3F', '#581845', '#FFC300', '#DAF7A6', '#FF5733', '#C70039', '#900C3F', '#581845', '#56BAEC', '#B6D7F2', '#8A2BE2', '#7FFF00', '#D2691E'] : ['#783597'],
                xaxis: this.chartType !== 'pie' ? {
                    categories: data.map(item => item.type)
                } : undefined,
                labels: this.chartType === 'pie' ? data.map(item => item.type) : [],
                plotOptions: {
                    bar: {
                        horizontal: false,
                    }
                },
                dataLabels: {
                    enabled: false
                },
                title: {
                    text: 'Erstelle Verbindungen in den letzten 30 Tagen',
                    align: 'center'
                }
            };
        }
    }
});
</script>

<style scoped>
.chart-controls {
    margin-bottom: 20px;
}
</style>